import React, { useState, useRef, useEffect } from "react";
import { Controller } from "react-hook-form";
import {
  Box,
  Card,
  CardContent,
  Grid,
  Button,
  IconButton,
  Chip,
  ButtonBase,
  Zoom,
  useTheme,
  makeStyles,
} from "@material-ui/core";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import { useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";

import CloseIcon from "@material-ui/icons/Close";

import { useAlert } from "../../components/Alert";
import LoadingModal from "../../components/LoadingModal";

const UPLOAD_IMAGE = gql`
  mutation UploadImage($image: Upload!) {
    uploadImage(image: $image) {
      filename
      mimetype
      location
    }
  }
`;

export default function UploadImage({ images, onChange }) {
  const arrayLength = useRef(0);
  const Alert = useAlert();
  const [preset, setPreset] = useState([]);
  // Zoom
  const [checkIndex, setCheckIndex] = useState("");
  //   styles
  const useStyles = makeStyles({
    zoomBox: {
      position: "fixed",
      backgroundColor: "rgba(0,0,0,0.7)",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      width: "100%",
      height: "100%",
      zIndex: 10,
      display: "flex",
      alignItems: "center",
    },
    zoomImage: {
      position: "absolute",
      top: "calc(50% + 64px)",
      left: "50%",
      transform: "translate(-50%,calc(-50% - 32px))",
      maxWidth: "80vw",
      maxHeight: "80vh",
      objectFit: "contain",
      borderRadius: "5px",
    },
  });
  const classes = useStyles();

  const [uploadImage, { loading: uploadImageLoading }] = useMutation(
    UPLOAD_IMAGE,
    {
      onCompleted({ uploadImage }) {
        const arr = images;
        arr?.push(uploadImage.location);
        onChange(arr);
      },
      onError(error) {
        return Alert.notice(`${error}`);
      },
    }
  );

  useEffect(() => {
    if (images.length < 5) {
      const remainingLength = 5 - images.length;
      const currentPreset = [];
      for (let index = 0; index < remainingLength; index++) {
        currentPreset.push(1);
      }
      setPreset(currentPreset);
    }
  }, [images]);

  return (
    <Box>
      <LoadingModal loading={uploadImageLoading} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          {/* ANHCOR 上傳明細 多張 */}
          <input
            type="file"
            style={{ display: "none" }}
            id="reciptsUploadImageInput"
            multiple
            onChange={(e) => {
              if (!!e.target.files) {
                const uploadImages = e.target.files;
                if (arrayLength.current + uploadImages.length > 5) {
                  return Alert.notice(`照片數量最多為5張！`);
                } else {
                  arrayLength.current += uploadImages.length;
                  for (let iterator of uploadImages) {
                    uploadImage({ variables: { image: iterator } });
                  }
                }
              }
            }}
          />
          <Box
            display="flex"
            alignItems="center"
            flexWrap="wrap"
            minHeight={"100px"}
          >
            {images?.map((item, index) => (
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                  margin: "0.5em",
                }}
              >
                <Zoom
                  in={checkIndex === index}
                  style={{
                    transitionDelay: checkIndex === index ? "300ms" : "0ms",
                  }}
                >
                  <Box className={classes.zoomBox}>
                    <img key={index} src={item} className={classes.zoomImage} />
                    {/* close */}
                    <IconButton
                      onClick={() => setCheckIndex("")}
                      style={{
                        position: "absolute",
                        top: "10%",
                        right: "10%",
                      }}
                    >
                      <CloseIcon
                        style={{
                          fontSize: "1.4rem",
                          color: "#fff",
                        }}
                      />
                    </IconButton>
                  </Box>
                </Zoom>
                <ButtonBase
                  style={{
                    width: "100px",
                    height: "100px",
                    border: "1px solid #404040",
                    padding: "5px",
                    borderRadius: "5px",
                  }}
                  onClick={() => {
                    setCheckIndex(index);
                  }}
                >
                  <img
                    key={index}
                    src={item}
                    width="100%"
                    height="100%"
                    style={{
                      objectFit: "cover",
                      borderRadius: "5px",
                    }}
                  />
                </ButtonBase>
                <IconButton
                  style={{ margin: "0.5em" }}
                  onClick={() => {
                    onChange(images.filter((i) => i["url"] !== item["url"]));
                  }}
                >
                  <HighlightOffIcon />
                </IconButton>
              </Box>
            ))}
            {preset.map((item, index) => (
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                  margin: "0.5em",
                }}
              >
                <Box
                  style={{
                    width: "100px",
                    height: "100px",
                    border: "1px solid #404040",
                    padding: "5px",
                    borderRadius: "5px",
                  }}
                >
                  <img
                    key={index}
                    src={require("../../images/logo192.png").default}
                    width="100%"
                    height="100%"
                    style={{
                      objectFit: "cover",
                      borderRadius: "5px",
                    }}
                  />
                </Box>
                <div style={{ minHeight: "58px", margin: "0.5em" }}></div>
              </Box>
            ))}
          </Box>
        </Grid>
        <Grid item xs={12} container justifyContent="center">
          <Button
            variant="contained"
            color="primary"
            style={{ color: "#fff" }}
            onClick={() => {
              const reciptsUploadImageInput = document.getElementById(
                "reciptsUploadImageInput"
              );
              reciptsUploadImageInput.click();
            }}
            disabled={images.length === 5}
          >
            上傳檔案
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}
